import { DEFAULT_REPORTING_SCOPE, REPORTING_SCOPES, ReportingScopeSchema, type ReportingScope } from "@packages/core/organization/scope.ts";

export const TEAM_SCOPES = REPORTING_SCOPES;
export const TeamScopeSchema = ReportingScopeSchema;
export type TeamScope = ReportingScope;

export const DEFAULT_TEAM_SCOPE: TeamScope = DEFAULT_REPORTING_SCOPE;
